import React from 'react';

import { Dropdown } from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';

const DropdownMenu = props => (
    <Dropdown id={props.id} className={props.className} size={props.size} drop={props.drop}>
        <Dropdown.Toggle id='dropdown-basic' variant={props.variant} style={props.style}>
            {
                props.prefixIcon && <i className={props.prefixIcon} style={{ marginRight: 4 }} />
            }
            {props.label}
        </Dropdown.Toggle>
        <Dropdown.Menu>
            {props.items.map((item, index) => {
                return <Dropdown.Item key={index} onClick={item.action} className={item.className} style={props.menuStyle}>
                    {
                        item.prefixIcon && <i className={item.prefixIcon} style={{ marginRight: 4 }} />
                    }
                    {item.label}
                </Dropdown.Item>;
            })}
        </Dropdown.Menu>
    </Dropdown>
);

export default DropdownMenu;
